<template>
  <div class="filter-coupon" id="filter-coupon" v-if="isEnable()">
    <div class="filter-coupon__search">
      <label class="form-label">Описание промокода</label>
      <div class="row g-2">
        <div class="col">
          <div class="input-icon">
            <input @keyup.enter="events.onSearch" type="text" v-model="data.search" class="form-control" placeholder="Описание промокода">
            <button class="btn input-icon-addon__button" @click="events.onSearch">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="10" cy="10" r="7" />
                <line x1="21" y1="21" x2="15" y2="15" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-sources__select">
      <label class="form-label">Источник</label>
      <Multiselect
        @change="events.onSelSourceId"
        v-model="data.sourceId"
        :close-on-select="true"
        :multiple="false"
        placeholder="Выберите источник"
        noResultsText="Результатов не найдено"
        :options=getSources()
        :searchable="true"
        :internal-search="true"
        label="title"
        track-by="title"
      >
        <template v-slot:singlelabel="{ value }">
          <div class="multiselect-single-label option-item">
            <div class="item-image-wrap">
              <img class="item-image" :src="value.image">
            </div>
            <div class="item-name">{{ value.title }}</div>
          </div>
        </template>
        <template v-slot:option="{ option }">
          <div class="option-item">
            <div class="item-image-wrap">
              <img class="item-image" :src="option.image">
            </div>
            <div class="item-name">{{ option.title }}</div>
          </div>
        </template>
      </Multiselect>
    </div>
    <div class="filter-shops__select">
      <label class="form-label">Магазин</label>
      <Multiselect
        @change="events.onSelShopId"
        v-model="data.shopId"
        :close-on-select="true"
        :multiple="false"
        placeholder="Выберите магазин"
        noResultsText="Результатов не найдено"
        :options=getShops()
        :searchable="true"
        :internal-search="true"
        label="title"
        track-by="title"
      >
        <template v-slot:singlelabel="{ value }">
          <div class="multiselect-single-label option-item">
            <div class="item-image-wrap">
              <img class="item-image" :src="value.image">
            </div>
            <div class="item-name">{{ value.title }}</div>
          </div>
        </template>
        <template v-slot:option="{ option }">
          <div class="option-item">
            <div class="item-image-wrap">
              <img class="item-image" :src="option.image">
            </div>
            <div class="item-name">{{ option.title }}</div>
          </div>
        </template>
      </Multiselect>
    </div>
  </div>
</template>

<script>
import './css/style.css'
import {defineComponent, onMounted, reactive, ref} from "vue"
import Api from "@/modules/promocodes/pages/shops/services/Api"
import Multiselect from "@/plugins/multiselect"
import Image from "@/services/Image"

export default defineComponent({
  name: "FilterCoupon",
  components: {
    Multiselect,
  },
  props: {
    params: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    let shops = ref([])
    let sources = ref([])

    const variantsData = reactive({
      categories: [],
    })

    let data = reactive({
      search: props.params.search ?? '',
      enable: props.params.search !== '' ||
          props.params.coupon_is_cancel !== ''  ||
          props.params.coupon_is_publish !== '' ||
          props.params.coupon_delst !== '' ||
          props.params.source_id !== 0 ||
          props.params.shop_id !== 0,
      couponIsCancel: props.params.coupon_is_cancel ?? '',
      couponIsPublish: props.params.coupon_is_publish ?? '',
      couponDelst: props.params.coupon_delst ?? '',
      sourceId: props.params.source_id ?? 0,
      shopId: props.params.shop_id ?? 0,
    })

    const events = {
      onSelSourceId: () => {
        onFilter()
      },
      onSelShopId: () => {
        onFilter()
      },
      onSelCouponIsCancel: () => {
        onFilter()
      },
      onSelCouponIsPublish: () => {
        onFilter()
      },
      onSelCouponDelst: () => {
        onFilter()
      },
      onSearch: () => {
        onFilter()
      },
      onStatuses: () => {
        onFilter()
      }
    }

    function onFilter() {
      setTimeout(() => {
        emit("onFilter", getResult())
      }, 300)
    }

    function getResult() {
      let ret = {}

      if (data.search !== '') {
        ret["search"] = data.search
      }
      if (data.couponIsCancel !== '') {
        ret["coupon_is_cancel"] = data.couponIsCancel
      }
      if (data.couponIsPublish !== '') {
        ret["coupon_is_publish"] = data.couponIsPublish
      }
      if (data.couponDelst !== '') {
        ret["coupon_delst"] = data.couponDelst
      }
      if (data.sourceId !== 0) {
        ret["source_id"] = data.sourceId
      }
      if (data.shopId !== 0) {
        ret["shop_id"] = data.shopId
      }

      return ret
    }

    function isEnable() {
      return props.params.enable === true
    }

    onMounted(() => {
      loadSources()
      loadShops()

      onFilter()
    })

    function loadShops() {
      Api.shops({limit: 10000, offset: 0}).then((resp) => {
        let items = resp.data.data
        let filtered = []

        filtered.push({
          value: 0,
          title: "Любой",
          image: "",
        })

        for (let prop in items) {
          let obj = items[prop]
          let image = null

          if (obj["shop_image_host"] && obj["shop_image_name"]) {
            image = Image.handle(obj["shop_image_host"], obj["shop_image_name"], 60)
          }

          filtered.push({
            value: obj["shop_id"],
            title: obj["shop_name"],
            image: image,
          })
        }

        shops.value = filtered
      }).catch(() => {})
        .finally(() => {})
    }

    function getSourceImage(sourceId) {
      let sourceImage = ""

      switch (sourceId) {
        case 1: sourceImage = "/assets/static/sources/admitad.svg"
        break
        case 2: sourceImage = "/assets/static/sources/advcake.svg"
        break
      }
      return sourceImage
    }

    function loadSources() {
      Api.sources().then((resp) => {
        let items = resp.data.data
        let filtered = []

        filtered.push({
          value: 0,
          title: "Любой",
          image: "",
        })

        for (let prop in items) {
          let obj = items[prop]

          filtered.push({
            value: obj["source_id"],
            title: obj["source_name"],
            image: getSourceImage(obj["source_id"]),
          })
        }

        sources.value = filtered
      }).catch(() => {})
        .finally(() => {})
    }

    function getShops() {
      return shops.value
    }

    function getSources() {
      return sources.value
    }

    return {
      events,
      data,
      variantsData,
      isEnable,
      getShops,
      getSources,
    }
  }
})
</script>
